import { Component } from 'react';

interface PriceChange {
    change: number;
    isPositive: boolean;
}

interface PriceChangePillsProps {
    oneYearChange?: PriceChange | null;
    oneMonthChange?: PriceChange | null;
    oneDayChange?: PriceChange | null;
}

class PriceChangePills extends Component<PriceChangePillsProps> {
    formatCompactPrice(value: number): string {
        if (value >= 1000000) return `€${(value / 1000000).toFixed(1)}M`;
        if (value >= 1000) return `€${Math.round(value / 1000)}K`;
        return `€${Math.round(value)}`;
    }

    render() {
        const { oneYearChange, oneMonthChange, oneDayChange } = this.props;
        if (!oneYearChange && !oneMonthChange && !oneDayChange) return null;

        return (
            <div className="price-changes-inline">
                {oneYearChange && (
                    <span className={`price-change-pill ${oneYearChange.isPositive ? 'positive' : 'negative'}`}>
                        {oneYearChange.isPositive ? '▲' : '▼'} {this.formatCompactPrice(Math.abs(oneYearChange.change))} <span className="pill-label">1Year</span>
                    </span>
                )}
                {oneMonthChange && (
                    <span className={`price-change-pill ${oneMonthChange.isPositive ? 'positive' : 'negative'}`}>
                        {oneMonthChange.isPositive ? '▲' : '▼'} {this.formatCompactPrice(Math.abs(oneMonthChange.change))} <span className="pill-label">1Month</span>
                    </span>
                )}
                {oneDayChange && (
                    <span className={`price-change-pill ${oneDayChange.isPositive ? 'positive' : 'negative'}`}>
                        {oneDayChange.isPositive ? '▲' : '▼'} {this.formatCompactPrice(Math.abs(oneDayChange.change))} <span className="pill-label">1Day</span>
                    </span>
                )}
            </div>
        );
    }
}

export default PriceChangePills;
